import { useEffect, useState } from "react";

import { ReceivingInvoiceDetailsViewModel } from "../../viewmodels/receiving/ReceivingInvoiceDetailsViewModel";

import { connect } from "react-redux";

import * as actions from "../../store/actions/index";

import { withRouter } from "../../shared/utility";

import AddReceivingInvoiceForm from "../../components/forms/receiving/AddReceivingInvoiceForm";
import EmptyModal from "../../components/modals/EmptyModal";
import { useParams } from "react-router-dom";
import { RecordLoadingSkeleton } from "../../components/shared/ContentLoadingSkeleton";

function ReceivingInvoiceDetails(props) {
  const { addSnackbar, logout } = props;

  const { receivingId } = useParams();
  const [initialLoading, setInitialLoading] = useState(true);

  const {
    emptyModal,
    setEmptyModelOpen,
    truckOptions,
    getTruckOptionsForDropdown,
    supplierOptions,
    getSupplierOptionsForDropdown,
    getProductOptionsForDropdown,
    productOptions,
    onFetchProductDetails,
    poOptions,
    receiving,
    addItemToReceiving,
    askDeleteReceivingItemById,
    updateReceivingItem,
    openDeleteItemByBarcodePopup,
    updateReceivingInvoice,
    getReceivingInvoiceDetails,
    employeeOptions,
    getEmployeeOptionsForDropdown,
    getWarehouses,
    getWarehouseLocations,
    onDeleteReceivingInvoice,
    deleteReceivingInvoiceDocument,
    askReturnSelectedItems,
    selectedItems,
    setSelectedItems,
    onUpdateUnitCostForReceivingItem,
    onUpdateTotalCostForReceivingItem,
    onUpdateGroupQuantities,
    printReceivingSummaryReport,
    printReceivingDetailsReport,
    loadingRows,
    rowDetails,
    fetchSubRowDetails,
    subRowDetails,
    subLoadingRows,
    fetchRowDetails,
    carrierOptions,
    getCarriersForDropdown,
  } = ReceivingInvoiceDetailsViewModel(logout, receivingId, addSnackbar);

  async function getInfoForInvoice() {
    try {
      // Wait for all async functions to complete
      await Promise.all([
        getTruckOptionsForDropdown(),
        getSupplierOptionsForDropdown(),
        getProductOptionsForDropdown(),
        getEmployeeOptionsForDropdown(),
        getCarriersForDropdown(),
      ]);

      // Run the final function
      await getReceivingInvoiceDetails();
    } catch (error) {
      console.error("An error occurred:", error);
    } finally {
      setInitialLoading(false);
    }
  }

  useEffect(() => {
    getInfoForInvoice();
  }, []);

  return (
    <div>
      <div className="mt-2 px-4 sm:px-8">
        {initialLoading ? (
          <RecordLoadingSkeleton />
        ) : (
          <AddReceivingInvoiceForm
          isEdit={true}
              truckOptions={truckOptions}
              productOptions={productOptions}
              supplierOptions={supplierOptions}
              onFetchProductDetails={onFetchProductDetails}
              poOptions={poOptions}
              setEmptyModelOpen={setEmptyModelOpen}
              receiving={receiving}
              getReceivingInvoiceDetails={getReceivingInvoiceDetails}
              addItemToReceiving={addItemToReceiving}
              askDeleteReceivingItemById={askDeleteReceivingItemById}
              updateReceivingItem={updateReceivingItem}
              openDeleteItemByBarcodePopup={openDeleteItemByBarcodePopup}
              updateReceivingInvoice={updateReceivingInvoice}
              employeeOptions={employeeOptions}
              getWarehouses={getWarehouses}
              getWarehouseLocations={getWarehouseLocations}
              isNewFlow={false}
              onDeleteReceivingInvoice={onDeleteReceivingInvoice}
              deleteReceivingInvoiceDocument={deleteReceivingInvoiceDocument}
              addSnackbar={addSnackbar}
              askReturnSelectedItems={askReturnSelectedItems}
              selectedItems={selectedItems}
              setSelectedItems={setSelectedItems}
              onUpdateUnitCostForReceivingItem={
                onUpdateUnitCostForReceivingItem
              }
              onUpdateTotalCostForReceivingItem={
                onUpdateTotalCostForReceivingItem
              }
              onUpdateGroupQuantities={onUpdateGroupQuantities}
              printReceivingSummaryReport={printReceivingSummaryReport}
              printReceivingDetailsReport={printReceivingDetailsReport}
              closed={receiving.status === 1}
              loadingRows={loadingRows}
              rowDetails={rowDetails}
              carrierOptions={carrierOptions}
              fetchSubRowDetails={fetchSubRowDetails}
              subRowDetails={subRowDetails}
              subLoadingRows={subLoadingRows}
              fetchRowDetails={fetchRowDetails}
          />
        )}
      </div>

      <EmptyModal
        childComponent={emptyModal.childComponent}
        open={emptyModal.open}
        setOpen={setEmptyModelOpen}
        size={emptyModal.size}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
    addSnackbar: (snackbar) => dispatch(actions.addSnackbar(snackbar)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ReceivingInvoiceDetails),
);
